// Grow gamification copy, ported from discovery's i18n bundles
// (enum.userrank.*, enum.praiseword.*, achievement.* in messages_de/_en).
// Used by the self-assessment result screen. genesis returns the raw
// UserRank enum (RANK1..RANK8); the human labels live here.

import type { UserRank } from "@/graphql/generated/types";

const RANK_LABELS: Record<UserRank, { de: string; en: string }> = {
  RANK1: { de: "Basisprofil", en: "Basic Profile" },
  RANK2: { de: "Qualifikationsprofil", en: "Qualification Profile" },
  RANK3: { de: "Erfahrungsprofil", en: "Experience Profile" },
  RANK4: { de: "Erweitertes Profil", en: "Extended Profile" },
  RANK5: { de: "Kompetenzprofil", en: "Competency Profile" },
  RANK6: { de: "Fortgeschrittenes Kompetenzprofil", en: "Advanced Competency Profile" },
  RANK7: { de: "Optimiertes Kompetenzprofil", en: "Optimized Competency Profile" },
  RANK8: { de: "Vollständiges Kompetenzprofil", en: "Complete Competency Profile" },
};

export function rankLabel(rank: UserRank, locale: string): string {
  const entry = RANK_LABELS[rank];
  if (!entry) return rank;
  return locale.startsWith("de") ? entry.de : entry.en;
}

const PRAISE_WORDS = {
  de: [
    "Hervorragend",
    "Großartig",
    "Sensationell",
    "Perfekt",
    "Ausgezeichnet",
    "Exzellent",
    "Brillant",
    "Fabelhaft",
    "Fantastisch",
    "Grandios",
  ],
  en: [
    "Outstanding",
    "Great",
    "Sensational",
    "Perfect",
    "Magnificent",
    "Excellent",
    "Brilliant",
    "Fabulous",
    "Fantastic",
    "Terrific",
  ],
} as const;

export function randomPraiseWord(locale: string): string {
  const words = locale.startsWith("de") ? PRAISE_WORDS.de : PRAISE_WORDS.en;
  return words[Math.floor(Math.random() * words.length)] ?? words[0];
}

export function achievementScoreText(score: number, locale: string): string {
  return locale.startsWith("de")
    ? `Du hast einen Score von ${score} erreicht.`
    : `You have achieved a score of ${score}.`;
}

export function achievementRankText(rankLabelText: string, locale: string): string {
  return locale.startsWith("de")
    ? `Dir wurde der Rang ${rankLabelText} verliehen.`
    : `You have been awarded the rank ${rankLabelText}.`;
}
